<div class="main-container" data-cy="note-builder-create-container">
  <mat-form-field class="note-input" data-cy="note-builder-description-field">
    <input matInput class="" placeholder="Write a description" [(ngModel)]="predefinedNote.NoteDescription" data-cy="note-builder-description-input">
  </mat-form-field>

  <mat-form-field class="note-input" data-cy="note-builder-template-field">
    <input matInput class="" placeholder="Write a note template" [(ngModel)]="predefinedNote.NoteTemplate" data-cy="note-builder-template-input">
  </mat-form-field>

  <div class="action-container" data-cy="note-builder-action-container">
    <button mat-button class="action-button" color="warn" (click)="cancel()" data-cy="note-builder-cancel-button">Cancel</button>
    <button mat-raised-button class="action-button" color="primary" (click)="save()" data-cy="note-builder-save-button">Save</button>
  </div>
</div>
